import {useState} from "react";
import {EVENT_SPACE} from "../../actions/spaces";
import {
    getPeekEventsFromDateUrl,
    getPeekParentSpacesUrl,
    getPeekPublicEventsFromDateUrl,
    getPeekPublicSpacesUrl
} from "../../actions/environment";
import {useAuthorization, useSiteConfiguration} from "../../selectors";
import {NONE_STATUS, PENDING_STATUS, SUCCESS_STATUS} from "../../actions";
import axios from "axios";
import {authConfig} from "../../actions/local-storage";
import useErrorHandler from "./use-error-handler";

const usePeekEventSpaces = () => {
    const [status, setStatus] = useState(NONE_STATUS);
    const [events, setEvents] = useState(null);
    const {isAuthorized} = useAuthorization();
    const {handleError, error} = useErrorHandler(setStatus);

    // authorized
    // @Deprecated
    const peekUserParentEvents = username => {
        setStatus(PENDING_STATUS);
        axios.get(getPeekParentSpacesUrl(username, EVENT_SPACE), authConfig())
        .then(response => {
            setEvents(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            console.log('peekUserParentEvents', error.response);
            handleError(error, () => peekUserParentEvents(username));
        })
    }

    // replaces peekUserParentEvents()
    const peekUserEventsFromDate = (username, fromDate) => {
        setStatus(PENDING_STATUS);
        axios.get(getPeekEventsFromDateUrl(username, fromDate), authConfig())
        .then(response => {
            setEvents(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            console.log('peekUserEventsFromDate', error.response);
            handleError(error, () => peekUserEventsFromDate(username, fromDate));
        })
    }

    // replaces peekPublicParentEvents
    const peekPublicEventsFromDate = (username, fromDate) => {
        setStatus(PENDING_STATUS);
        axios.get(getPeekPublicEventsFromDateUrl(username, fromDate), authConfig())
        .then(response => {
            setEvents(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            console.log('peekPublicEventsFromDate', error.response);
            handleError(error, () => peekPublicEventsFromDate(username, fromDate));
        })
    }

    // not authorized
    // @Deprecated
    const peekPublicParentEvents = username => {
        setStatus(PENDING_STATUS);
        axios.get(getPeekPublicSpacesUrl(username, EVENT_SPACE), authConfig())
        .then(response => {
            setEvents(response.data);
            setStatus(SUCCESS_STATUS);
        })
        .catch(error => {
            console.log('peekPublicParentEvents', error.response);
            handleError(error, () => peekPublicParentEvents());
        })
    }

    const peekEventSpacesFromDate = (username, fromDate) => {
        if (isAuthorized) {
            peekUserEventsFromDate(username, fromDate)
        } else {
            peekPublicEventsFromDate(username, fromDate);
        }
    }

    // @Deprecated
    const peekEventSpaces = (username, isParent) => {
        if (isAuthorized) {
            peekUserParentEvents(username)
        } else {
            peekPublicParentEvents(username);
        }
    }

    return {
        peekEventSpaces: peekEventSpaces,
        peekEventSpacesFromDate: peekEventSpacesFromDate,
        events: events,
        status: status}
}

export default usePeekEventSpaces;